import React, { useEffect } from "react";
import { LuPencil } from "react-icons/lu";
import styles from "./ImagePicker.module.scss";
import defaultProductImage from "../../../assets/images/product-single.jpg";
import { useFilePicker } from "./useFilePicker";

export default function ImagePicker(props) {
  const { click, file } = useFilePicker({ format: "image/*" });
  const defaultImage = props.defaultImage
    ? props.defaultImage.url
    : defaultProductImage;

  useEffect(() => {
    if (!file) return;
    props.onChange && props.onChange(file);
  }, [file]);

  return (
    <div
      className={`${styles.container} ${props.className}`}
      style={props.containerStyles}
    >
      <img
        className={styles.image}
        src={(file && file.url) || defaultImage}
        alt=""
      />
      <button className={styles.btn} onClick={click} type="button" title="Trocar imagem">
        <LuPencil size={14} />
      </button>
    </div>
  );
}
